import { render, staticRenderFns } from "./DSLink.vue?vue&type=template&id=5ef9d814&scoped=true&"
import script from "./DSLink.vue?vue&type=script&lang=ts&"
export * from "./DSLink.vue?vue&type=script&lang=ts&"
import style0 from "./DSLink.vue?vue&type=style&index=0&id=5ef9d814&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ef9d814",
  null
  
)

export default component.exports